import React from 'react';
import { Search, Package, Download } from 'lucide-react';

const HowItWorksSection = ({ content }) => {
  const defaultSteps = [
    { title: 'Choose Your Guides', description: 'Browse our research-backed resources for sleep, behavior, screen time, and family connection.' },
    { title: 'Build Your Bundle', description: 'Mix and match products to create your perfect system. Save up to 25% with bundles.' },
    { title: 'Download & Transform', description: 'Get instant access to your guides. Start implementing proven systems today.' },
  ];
  const cmsSteps = Array.isArray(content?.steps) && content.steps.length ? content.steps : defaultSteps;
  const stepIcons = [Search, Package, Download];
  const steps = cmsSteps.map((s, i) => ({
    number: String(i + 1).padStart(2, '0'),
    icon: stepIcons[i % stepIcons.length],
    title: s.title || '',
    description: s.description || '',
  }));

  const eyebrow = content?.eyebrow || 'Simple Process';
  const heading = content?.heading || 'How It Works';
  const description = content?.description || 'From overwhelmed to organized in three simple steps';

  return (
    <section className="py-16 lg:py-24 bg-[#F8FAFC]" data-testid="how-it-works-section">
      <div className="wrap">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="text-[#0F766E] font-semibold text-sm uppercase tracking-wider">{eyebrow}</span>
          <h2 className="text-3xl lg:text-[40px] font-bold mt-3 mb-4 text-[#0B1F3A]">
            {heading}
          </h2>
          <p className="text-[#475569] max-w-xl mx-auto text-lg">
            {description}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#E2E8F0] to-transparent"></div>
              )}
              
              <div className="text-center group">
                {/* Step Icon */}
                <div className="inline-flex items-center justify-center mb-6">
                  <div className="relative w-24 h-24 rounded-2xl bg-white border border-[#E2E8F0] flex items-center justify-center group-hover:border-[#0F766E]/30 group-hover:shadow-lg transition-all duration-300">
                    <step.icon className="h-10 w-10 text-[#0F766E]" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#0F766E] flex items-center justify-center text-white text-sm font-bold shadow-lg">
                      {step.number}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold mb-3 text-[#0B1F3A]">
                  {step.title}
                </h3>
                <p className="text-[#475569] leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
